import { useEffect, useMemo, useState } from 'react'
import { getObjectsWithFilter } from '../../../api/apiClientCrud'
import { toast } from 'react-toastify'
import ListModule from '../../module/ListModule'
import { useAuth } from '../../../context/AuthContext'
import { useOutletContext } from 'react-router-dom'
import { getInvoiceColumns } from './InvoiceFields'
import Loading from '../../common/Loading'
import DocumentPreview from '../../document/DocumentPreview'
import Invoice from './Invoice'
import { Box } from '@mui/material'

const ListInvoice = () => {
  const [statusList, setStatusList] = useState([])
  const [customers, setCustomers] = useState([])
  const { user } = useAuth()
  const userRight = useOutletContext()

  useEffect(() => {
    const loadData = async () => {
      try {
        const [statusListRes, customersRes] = await Promise.all([
          getObjectsWithFilter('status', { object: 'invoices' }),
          getObjectsWithFilter('customers', { company_id: user.company_id })
        ])
        setStatusList(Array.isArray(statusListRes.data) ? statusListRes.data : [])
        setCustomers(Array.isArray(customersRes.data?.customers) ? customersRes.data.customers : [])
      } catch (error) {
        toast.error('Erreur lors du chargement', { autoClose: 2000 })
      }
    }

    loadData()
  }, [user.company_id])

  const columns = useMemo(() => {
    if (!statusList.length || !customers.length) return []
    return getInvoiceColumns({ statusList, customers })
  }, [statusList, customers])

  const options = useMemo(
    () => ({
      objectType: 'invoices',
      accessRight: userRight,
      actionColumnPosition: 'first',
      objectFilter: () => {
        return { company_id: user.company_id }
      },
      actions: {
        add: true,
        edit: true,
        editDisabled: (invoice) => invoice.status >= 70,
        view: true,
        delete: {
          message: 'Voulez-vous vraiment supprimer la facture',
          field: 'invoice_number'
        }
      },
      isFilter: true,
      isExpand: true,
      defaultSorted: 'invoice_number',
      expand: (row) => <DocumentPreview Component={Invoice} document={row} />,
      columns
    }),
    [userRight, user.company_id, columns]
  )

  const toolbar = useMemo(
    () => ({
      objectType: 'invoices',
      title: 'Factures',
      accessRight: userRight,
      actions: {
        add: true
      },
      columns: options.columns,
      isFilter: true,
      columnVisibility: true
    }),
    [userRight, options]
  )

  if (!columns.length)
    return (
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          height: '100%',
          minHeight: '100px',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Loading />
      </Box>
    )

  return <ListModule options={options} toolbar={toolbar} />
}

export default ListInvoice
